import { render, staticRenderFns } from "./SummaryData.vue?vue&type=template&id=c6286098&scoped=true&"
import script from "./SummaryData.vue?vue&type=script&lang=js&"
export * from "./SummaryData.vue?vue&type=script&lang=js&"
import style0 from "./SummaryData.vue?vue&type=style&index=0&id=c6286098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6286098",
  null
  
)

export default component.exports